import { Fragment } from "react";
import { Disclosure } from "@headlessui/react";
import { Transition } from "@headlessui/react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import AuthenticationService from "../../services/AuthenticationService";
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import Tooltip from "@ui-components/Tooltip";
import useMediaQuery from "@hooks/useMediaQuery";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const MenuDropdown = ({
    name, Icon, dropdown, clickable = true, setClickable, onTouchEnd = () => {
    }
}) => {
    const { pathname } = useLocation();
    const scopes = AuthenticationService.getUserScopes();
    const isMobile = useMediaQuery('(max-width: 1024px)');


    if (!dropdown?.length) {
        return null;
    }

    const active = dropdown.reduce(
        (acc, { href }) => (!acc && pathname.indexOf(href) >= 0 ? true : acc),
        false
    );

    return (
        <Disclosure as="div" key={name} className="space-y-1">
            {({ open }) => (
                <>

                    {clickable || isMobile ? (
                        <Disclosure.Button
                            className={classNames(
                                active
                                    ? "bg-gray-200 shadow-md item-center truncate text-black border border-transparent"
                                    : "text-black hover:border hover:border-gray-100  hover:text-black hover:shadow-lg border border-transparent",
                                "flex items-center px-3 py-3 text-base font-medium w-full justify-between rounded-3xl truncate"
                            )}
                            onClick={() => {
                                setClickable();
                            }}
                        >
                            <div className="flex items-left">
                                <Icon
                                    className={classNames(
                                        active ? "text-black" : "text-black",
                                        "mr-4 h-6 w-6"
                                    )}
                                    aria-hidden="true"
                                />
                                <span className={"ml-1 flex-1 w-[48px]"}>
                                    {name}
                                </span>

                            </div>
                            <ChevronDownIcon className={classNames(
                                open ? "text-black rotate-180" : "text-black",
                                "shrink-0 h-5 w-5 group-hover:text-black transition-colors ease-in-out duration-300 flex"
                            )} />

                        </Disclosure.Button>

                    ) :
                        <div
                            className={classNames(active ? " bg-grey-20 flex justify-center shadow-md" : "flex item-center justify-center",
                                "h-[48px] w-[48px] group flex items-center text-base font-medium rounded-3xl hover:border hover:border-gray-20 hover:shadow-md")}>
                            <Tooltip text={name} placement="right">
                            <button onClick={() => setClickable()}>
                                <Icon
                                    className={classNames(active ? "bg-gray-20 flex justify-center" : "",
                                        "h-[24px] w-[24px]")}
                                    aria-hidden="true"
                                />
                            </button>
                            </Tooltip>
                        </div>
                    }
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Disclosure.Panel className="rounded-3xl p-2 space-y-2 origin-top">
                            {clickable && dropdown
                                .filter((item) => {
                                    if (!item.scopes) {
                                        return true;
                                    }

                                    return item.scopes.some((r) => scopes.indexOf(r) >= 0);
                                })
                                .map((subItem) => {
                                    const subActive = pathname.indexOf(subItem.href) >= 0;

                                    return (
                                        <Link
                                            key={subItem.name}
                                            to={subItem.href}
                                            className={classNames(
                                                subActive ? "bg-am-600 rounded-2xl text-white hover:text-white" : "border border-transparent",
                                                "group flex h-10 items-center hover:text-black text-sm" +
                                                " font-medium text-black hover:text-black hover:border hover:rounded-2xl hover:border-am-600 pl-11"
                                            )}
                                            onTouchEnd={() => onTouchEnd()}
                                        >
                                            {subItem.name}
                                        </Link>
                                    );
                                })}
                        </Disclosure.Panel>
                    </Transition>
                </>
            )}
        </Disclosure>
    );
};

export default MenuDropdown;
